<template>
  <div class="image-teaser">
    <slot name="default" />
    <div
      v-if="$slots.content"
      class="it-content"
      :class="{
        'it-content--bottom': contentBottom,
        'it-content--centered': contentCentered,
      }"
    >
      <slot name="content" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    contentBottom: {
      type: Boolean,
    },
    contentCentered: {
      type: Boolean,
    },
  },
};
</script>

<style lang="scss" scoped>
.image-teaser {
  position: relative;
  display: block;
  overflow: hidden;
  border-radius: map-get($border-radiuses, 'l');

  img {
    width: 100%;
    display: block;
  }

  .it-content {
    position: absolute;
    left: $pad;
    top: $pad;
    right: $pad;
    width: calc(100% - 32px);

    @include bp(m) {
      left: $pad * 3;
      top: $pad * 3;
      right: $pad * 3;
      width: calc(100% - 96px);
    }

    &.it-content--bottom {
      bottom: $pad * 3;
      top: auto;
    }

    &.it-content--centered {
      left: 50%;
      transform: translateX(-50%);
      text-align: center;
    }
  }
}
</style>
